import { Suspense } from 'react'
import Field from '../../../../fields'
import EditProfileCard, { CardFields } from '../EditProfileCard'

type EmploymentCardProps = {
  fields: Record<string, any>
  formId: string
  teamMemberEnabled?: boolean
  testId?: string
}

const EmploymentCard = ({
  fields,
  formId,
  teamMemberEnabled,
  testId
}: EmploymentCardProps) => (
  <EditProfileCard title="Employment details" testId={testId}>
    <Suspense fallback={<div>Loading...</div>}>
      <CardFields>
        <Field
          className="startdate-field"
          keys="startDate"
          placeholders="DD-MM-YYYY"
          formId={formId}
          label="Start Date"
          type="date"
          values={fields}
        />
        {teamMemberEnabled && (
          <Field
            className="enddate-field"
            keys="endDate"
            placeholders="DD-MM-YYYY"
            formId={formId}
            label="End Date"
            type="date"
            values={fields}
          />
        )}
      </CardFields>
    </Suspense>
  </EditProfileCard>
)

export default EmploymentCard
